<script setup lang="ts">
  import ElLink from '@/components/common/ElLink/ElLink.vue';
  import type { INavigationItem } from '@/components/common/ElNavigation/elNavigation';

  defineOptions({ name: 'ElNavigationItem' });

  defineEmits<{
    click: [e: Event];
  }>();

  defineProps<
    INavigationItem & {
      /** classes optionnelles, spécifiques appliquées au lien */
      linkClasses?: string;
      /** Application de la classe active sur une route exacte (ou non) */
      matchExact?: boolean;
    }
  >();
</script>
<template>
  <li
    class="el-menu-item items-center"
    :class="$attrs.class"
  >
    <ElLink
      v-bind="$props"
      class="flex size-full items-center justify-center gap-2 px-4 text-center no-underline md:px-0"
      :class="linkClasses"
      @click="$emit('click', $event)"
    >
      <slot :label="label">
        {{ label }}
      </slot>
      <slot name="suffix-icon" />
    </ElLink>
  </li>
</template>
